import { toString } from 'lodash-es';
import { useMemo } from 'react';
import { getDeviceData } from './SyncConfigurationStoreModal.util';
import { useDeviceManagementCapability } from '../../hooks';
import type { DashboardRowDataTypeLoader } from '../../model/merchant.model';
import { useDevicesFromStoreQuery } from '../../hooks/useDevicesFromStoreQuery.hook';

export interface UseSyncConfigurationStoreModalParams {
  readonly storeId: string;
  readonly isOpen: boolean;
}

export function useSyncConfigurationStoreModal({
  isOpen,
  storeId,
}: UseSyncConfigurationStoreModalParams): DashboardRowDataTypeLoader {
  const memoStoreId = useMemo(() => toString(storeId), [storeId]);
  const hasDevicesPermission = useDeviceManagementCapability('logicalDevice.list');
  const shouldRequestDevicesData = isOpen && hasDevicesPermission;
  const {
    devicesData,
    isDevicesError,
    isDevicesLoading: isLoading,
  } = useDevicesFromStoreQuery(memoStoreId, shouldRequestDevicesData);

  return { ...getDeviceData(devicesData, isDevicesError, hasDevicesPermission, 'store.id', memoStoreId), isLoading };
}
